export default {
  "content": "<circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#F6F6F9\"/><g clip-path=\"url(#a)\"><path d=\"M22.7 20.8c-.62-.46-1.647-4.067-2.28-8a4.52 4.52 0 00-3.413-3.28.993.993 0 00-1.94-.087 4.61 4.61 0 00-3.887 3.547c-.413 3.82-1.253 7.353-1.847 7.82a.6.6 0 100 1.2h4.78a2 2 0 003.774 0H22.7a.6.6 0 100-1.193zm-4.893-4.327L15.14 19.14a.665.665 0 01-.947 0 .665.665 0 010-.947l1.534-1.526H14a.67.67 0 01-.613-.414.67.67 0 01.14-.726l2.666-2.667a.668.668 0 011.092.217.67.67 0 01-.145.73l-1.533 1.526h1.726a.67.67 0 01.614.414.67.67 0 01-.14.726\" fill=\"#717684\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M8 8h16v16H8z\"/></clipPath></defs>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};